// src/lib/config.js
function env(key) {
  if (typeof process !== "undefined" && process.env && process.env[key]) {
    return String(process.env[key]).trim();
  }
  return "";
}

let API_BASE = env("REACT_APP_API_BASE");

if (!API_BASE) {
  const host = window.location.hostname;
  if (host === "localhost" || host === "127.0.0.1") {
    // local dev -> talk to your droplet via nginx /api
    API_BASE = "http://137.184.82.29/api";
  } else {
    // production -> same-origin /api (nginx proxies to uvicorn)
    API_BASE = `${window.location.origin}/api`;
  }
}

export { API_BASE };
